/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "13.2.0";
